import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import PlatformSidebar from "./PlatformSidebar";
import { PlatformAppBar } from "./PlatformAppBar";
import { DRAWER_WIDTH } from "@/theme/crmTheme";

function PlatformShell() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Drawer
        variant="temporary"
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: { md: "none" },
          "& .MuiDrawer-paper": { width: DRAWER_WIDTH },
        }}
      >
        <PlatformSidebar onNavigate={() => setOpen(false)} />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          width: DRAWER_WIDTH,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: DRAWER_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        <PlatformSidebar />
      </Drawer>
      <Box
        component="section"
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <PlatformAppBar
          onMenuClick={() => setOpen(true)}
          drawerWidth={DRAWER_WIDTH}
        />
        <Box sx={{ flex: "1 0 auto", mt: { xs: "60px", md: "68px" } }}>
          <Box
            component="main"
            sx={{
              p: { xs: 1.25, sm: 2.5, md: 3.5 },
              bgcolor: "background.default",
              minHeight: "calc(100vh - 68px)",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default PlatformShell;
